import React, { useEffect, useState } from "react";
import Send_Button_Modal from "../common_components/common-modals/send-btn-modal/Send_Button_Modal";
import Call_Now_Modal from "../common_components/common-modals/call-now-modal/Call_Now_Modal";
import Common_Headings from "../common_components/common_heading/Common_Headings";
import Common_Vendor_Card from "../common_components/common-vendor-card/Common_Vendor_Card";
import Pagination_Holder from "../common_components/pagination-holder/Pagination_Holder";
import "./Vendors.css";
import { useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getVendorExpert } from "../../features/admin/vendor_expert/Slice";
import { AllCategories } from "../../features/admin/common/Slice";

function Vendor() {
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();

  const type = searchParams.get("type");
  const seeAll = searchParams.get("see_all_status");
  const materialId = searchParams.get("material_id[0]");

  useEffect(() => {
    dispatch(AllCategories());
    if (seeAll === "1" && materialId) {
      dispatch(
        getVendorExpert({
          type,
          material_id: [materialId],
          see_all_status: 1,
        }),
      );
    }
  }, [type, seeAll, materialId]);

  const categories =
    useSelector((state) => state?.common?.all_categories) || [];

  // Now materialId is available here
  const selectedCategory = categories.find(
    (c) => Number(c.id) === Number(materialId),
  );

  const plans =
    useSelector((state) => state?.vendor_expert?.vendorexperts?.vendorPlans) ||
    [];

  const allVendors = plans.flatMap((plan) => plan.vendors || []);

  const [showInquiry, setShowInquiry] = useState(false);
  const [showCall, setShowCall] = useState(false);

  const itemsPerPage = 9;
  const [currentPage, setCurrentPage] = useState(1);

  const totalPages = Math.ceil(allVendors.length / itemsPerPage);

  const paginatedData = allVendors.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage,
  );

  return (
    <div className="container mt-4 vendor-section">
      {/* ✅ Category name from "See All" */}
      <Common_Headings title={selectedCategory?.name} />

      <div className="row">
        {paginatedData.length ? (
          paginatedData.map((vendor) => (
            <div
              key={vendor.id}
              className="col-12 col-sm-6 col-md-6 col-lg-4 mb-4"
            >
              <Common_Vendor_Card
                vendor={vendor}
                onClick={() => setShowInquiry(true)}
                onClick2={() => setShowCall(true)}
              />
            </div>
          ))
        ) : (
          <p className="text-muted text-center">No vendors found</p>
        )}
      </div>

      <div className="row mt-4 mb-5">
        <Pagination_Holder
          onPageChange={currentPage}
          totalPages={totalPages}
          handlePageChange={setCurrentPage}
        />
      </div>

      <Send_Button_Modal
        show={showInquiry}
        handleClose={() => setShowInquiry(false)}
      />
      <Call_Now_Modal show={showCall} handleClose={() => setShowCall(false)} />
    </div>
  );
}

export default Vendor;
